import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/buildhome/repo/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyboardShortcuts"] */ "/opt/buildhome/repo/src/components/KeyboardShortcuts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/opt/buildhome/repo/src/components/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/PosthogPageView.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/tailwind.css");
